import {
  AssessmentScore,
  AssessmentTreatmentSteps,
  AssessmentTreatment,
  Testimonials
} from '@cerebral-inc/wode-screener-questions';
import { DEPRESSION_ASSESSMENT_SCORING } from 'constants/localStorageKey';
import { getStaticFilePath } from 'components/shared/utils';
import { DEPRESSION } from 'components/shared/types';
import { AssessmentWrapper } from 'components/shared/styled';
import { assessmentData } from './constants';
import { IAssessmentData } from './types';

const ScreenerAssessmentResult = () => {
  const score = Number(localStorage.getItem(DEPRESSION_ASSESSMENT_SCORING));
  const { assessmentScore, assessmentTreatment, steps } =
    assessmentData as IAssessmentData;

  const handleContinue = async () => {
    window.open(`${process.env.REACT_APP_CLIENT_APP_URL}`, '_self');
  };

  return (
    <AssessmentWrapper>
      <AssessmentScore
        score={Number(score)}
        maxScore={27}
        title={assessmentScore.title}
        description={assessmentScore.description}
        serviceLine={DEPRESSION}
        onSubmit={handleContinue}
        buttonText={assessmentScore.buttonText}
      />
      <AssessmentTreatment
        title={assessmentTreatment.title}
        description={assessmentTreatment.description}
        onSubmit={handleContinue}
        ctaText={assessmentTreatment.ctaText}
        subscript={assessmentTreatment.subscript}
        treatmentOptions={assessmentTreatment.treatmentOptions}
        cerebralRx={assessmentTreatment.cerebralRx}
        image={getStaticFilePath(assessmentTreatment.image.desktop)}
      />
      <AssessmentTreatmentSteps onSubmit={handleContinue} steps={steps} />
      <Testimonials />
    </AssessmentWrapper>
  );
};

export default ScreenerAssessmentResult;
